@if (breadcrumbs.length) {
    <ng-template #item let-file="file">
        @if (isImage(file)) {
            <img
                [nzDisablePreview]="true"
                [nzFallback]="fallback"
                [alt]="file.filename"
                [nzSrc]="file.url"
                nz-image
            />
        } @else {
            <div class="extension-card">
                {{ getExtension(file.filename) }}
            </div>
        }
    </ng-template>
    <ng-template #actions let-file="file">
        <button
            (click)="handleImagePreview({ src: file.url, alt: file.filename }, file)"
            nzShape="circle"
            nzType="primary"
            nz-button
        >
            <nz-icon nzType="eye" nzTheme="outline"></nz-icon>
        </button>

        @if (getIsSelectable(file)) {
            <button
                (click)="handleFileSelection(file)"
                class="success-button"
                nzShape="circle"
                nzType="primary"
                nz-button
            >
                <nz-icon nzType="check" nzTheme="outline"></nz-icon>
            </button>
        }
    </ng-template>

    <nz-modal
        nzClassName="file-manager-modal"
        [(nzVisible)]="isVisible"
        [nzTitle]="modalTitle"
        [nzFooter]="modalFooter"
        (nzOnCancel)="handleCloseFileManagerModal()"
        [nzWidth]="1850"
        [nzCentered]="true"
        [nzClosable]="false"
    >
        <ng-template #modalTitle>
            <div class="modal__header">
                <h2>
                    {{ "i18n.file_manager.upload_file" | translate }}
                    {{ nzAccept ? "(" + nzAccept + ")" : "" }}
                </h2>
                <div class="modal__actions">
                    <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        type="button"
                        class="modal__button"
                        (click)="handleOpenSearchDialog()"
                    >
                        <nz-icon nzType="search" nzTheme="outline"></nz-icon>
                    </button>

                    <button
                        nz-button
                        nzType="default"
                        nzShape="circle"
                        type="button"
                        class="modal__button"
                        (click)="handleOpenCreateFolderDialog()"
                    >
                        <nz-icon nzType="folder-add" nzTheme="outline"></nz-icon>
                    </button>

                    <form nz-form>
                        <nz-upload
                            [nzAccept]="nzAccept"
                            [nzShowUploadList]="false"
                            [nzMultiple]="true"
                            [nzBeforeUpload]="handleBeforeUpload"
                        >
                            <button
                                nz-button
                                class="modal__button"
                                nzType="primary"
                                nzShape="circle"
                                type="button"
                            >
                                <nz-icon nzType="cloud-upload" nzTheme="outline"></nz-icon>
                            </button>
                        </nz-upload>
                    </form>

                    <button
                        nz-button
                        class="modal__button"
                        nzType="text"
                        nzShape="circle"
                        type="button"
                        (click)="handleCloseFileManagerModal()"
                    >
                        <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                    </button>
                </div>
            </div>
        </ng-template>

        <ng-container *nzModalContent>
            <div class="file-manager">
                <nz-breadcrumb class="file-manager__breadcrumbs">
                    <nz-breadcrumb-item
                        [class]="{
                            'file-manager__breadcrumb-item': true,
                            'file-manager__breadcrumb-item--current':
                                breadcrumbs.length === 1 && !breadcrumbs[0],
                        }"
                    >
                        <button
                            nz-button
                            class="file-manager__breadcrumb-button"
                            nzType="text"
                            type="button"
                            (click)="navigateToFolder('/')"
                        >
                            <nz-icon nzType="home"></nz-icon>
                        </button>
                    </nz-breadcrumb-item>

                    @if (!!breadcrumbs.length && breadcrumbs[0] !== "") {
                        @for (
                            breadcrumb of breadcrumbs;
                            track breadcrumb;
                            let idx = $index;
                            let isLast = $last
                        ) {
                            <nz-breadcrumb-item
                                [class]="{
                                    'file-manager__breadcrumb-item': true,
                                    'file-manager__breadcrumb-item--current': isLast,
                                }"
                            >
                                @if (!isLast) {
                                    <button
                                        nz-button
                                        class="file-manager__breadcrumb-button"
                                        nzType="text"
                                        type="button"
                                        (click)="
                                            navigateToFolder(
                                                breadcrumbs.slice(0, idx + 1).join('/')
                                            )
                                        "
                                    >
                                        <span>{{ breadcrumb }}</span>
                                    </button>
                                } @else {
                                    <span>{{ breadcrumb }}</span>
                                }
                            </nz-breadcrumb-item>
                        }
                    }
                </nz-breadcrumb>

                <div class="file-manager__content">
                    @if (isLoading) {
                        <app-loader />
                    } @else {
                        @if (folders.length) {
                            <nz-collapse nzGhost>
                                <nz-collapse-panel
                                    [nzHeader]="'i18n.file_manager.folders' | translate"
                                    [nzActive]="true"
                                >
                                    <nz-list class="file-manager__folder-grid" nzSize="small">
                                        @for (folder of folders; track folder) {
                                            <nz-list-item
                                                class="file-manager__folder-item"
                                                tabindex="0"
                                            >
                                                <button
                                                    nz-button
                                                    class="file-manager__folder-button"
                                                    type="button"
                                                    (click)="navigateToFolder(folder)"
                                                >
                                                    <nz-icon
                                                        nzType="folder-open"
                                                        nzTheme="outline"
                                                    ></nz-icon>
                                                    <span>{{ folder.split("/").pop() }}</span>
                                                </button>
                                            </nz-list-item>
                                        }
                                    </nz-list>
                                </nz-collapse-panel>
                            </nz-collapse>
                        }

                        <nz-collapse nzGhost>
                            <nz-collapse-panel
                                [nzHeader]="'i18n.file_manager.files' | translate"
                                [nzActive]="true"
                            >
                                @if (files.length === 0) {
                                    <p class="no-files">
                                        {{ "i18n.file_manager.no_files_available" | translate }}
                                    </p>
                                } @else {
                                    <nz-list class="file-manager__file-grid" nzSize="small">
                                        @for (file of files; track file.filename) {
                                            <nz-list-item class="file-manager__file-item">
                                                <nz-card class="file-manager__card_item">
                                                    <ng-container
                                                        *ngTemplateOutlet="item; context: { file }"
                                                    ></ng-container>
                                                    <div class="file-manager__file-actions">
                                                        <ng-container
                                                            *ngTemplateOutlet="
                                                                actions;
                                                                context: { file }
                                                            "
                                                        ></ng-container>
                                                    </div>
                                                </nz-card>
                                                <p class="file-manager__file-name">
                                                    {{ file.filename }}
                                                </p>
                                                <div class="file-manager__confirm-icon">
                                                    <nz-icon
                                                        nzType="check"
                                                        nzTheme="outline"
                                                    ></nz-icon>
                                                </div>
                                            </nz-list-item>
                                        }
                                    </nz-list>
                                }
                            </nz-collapse-panel>
                        </nz-collapse>
                    }
                </div>
            </div>
        </ng-container>

        <ng-template #modalFooter>
            <nz-pagination
                [(nzPageIndex)]="currentPage"
                [nzPageSize]="perPage"
                [nzTotal]="totalFiles"
                [nzShowTotal]="paginationTotalTemplate"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[10, 20, 30, 40, 50]"
                (nzPageIndexChange)="handleChangePageIndex($event)"
                (nzPageSizeChange)="handleChangePageSize($event)"
                nzAlign="end"
            ></nz-pagination>
        </ng-template>

        <ng-template #paginationTotalTemplate let-range="range" let-total>
            {{ range[0] }}-{{ range[1] }} {{ "i18n.file_manager.paginator_of" | translate }}
            {{ total }} {{ "i18n.file_manager.paginator_items" | translate }}
        </ng-template>
    </nz-modal>
}

<ng-template #modalTemplate></ng-template>
